<template>
  <div class="item" @click="$emit('click', item)">
    <div class="img">
      <img v-if="item.cover && item.cover.url" class="img-common" :src="item.cover.url" />
    </div>

    <div class="item-content">
      <div class="rate">
        <el-rate 
          show-score 
          text-color="#ff9900" 
          disabled
          v-model="rate"
          :score-template="showScore"
        ></el-rate>
      </div>

      <div class="top-title line-clamp-1">{{ item.name || item.title }}</div>

      <div class="flex justify-between content-bottom">
        <div class="left flex items-center">
          <div class="el-icon-video-play icon"></div>
          <div class="text mr-2" :title="`总播放量: ${item.hits}`">{{ item.hits }}</div>

          <div class="el-icon-user-solid icon"></div>
          <div class="text" :title="`总计观看人数: ${item.count}`">{{ item.count }}</div>
        </div>
        <div class="right flex items-center">
          <div class="el-icon-time icon"></div>
          <div class="text" :title="`总计播放时长: ${ Math.ceil(item.duration) }`">{{ Math.ceil(item.duration) }}min</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    rate() {
      if (this.item.score) {
        const source = Number(this.item.score)

        if (source > 0) {
          return source / 2
        } else {
          return 5
        }
      }

      return 5
    },

    showScore() {
      if (this.item.score) {
        const source = Number(this.item.score)

        if (source > 0) {
          return String(source)
        } else {
          return '10'
        }
      }

      return '10'
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  background: #FFFFFF;
  box-shadow: 0 6px 10px 0 rgb(95 101 105 / 15%);
  border-radius: 10px;
  cursor: pointer;
  transition: all .2s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 20px 0 rgb(95 101 105 / 15%);
  }

  .img {
    height: 158px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .item-content {
    padding: 15px 10px;

    .rate {
      margin-bottom: 5px;
    }

    .top-title {
      font-size: 16px;
      height: 20px;
      line-height: 20px;
      margin-bottom: 10px;
      color: #545c63;;
    }

    .content-bottom {
      .icon {
        font-size: 18px;
        color: rgb(247, 186, 42);
        margin-right: 3px;
      }

      .text {
        font-size: 14px;
        color: #9199A1;
        line-height: 1;
      }
    }
  }
}
</style>
